import React, { useEffect, useState } from "react";

// The book's ASIN is the same across every Amazon marketplace.
const ASIN = "B0G5PWW1QX";

// Map a visitor's country (from their browser locale) to the right Amazon domain.
const AMAZON_DOMAINS = {
  US: "amazon.com",
  GB: "amazon.co.uk",
  UK: "amazon.co.uk",
  IE: "amazon.co.uk",
  CA: "amazon.ca",
  MX: "amazon.com.mx",
  BR: "amazon.com.br",
  DE: "amazon.de",
  AT: "amazon.de",
  CH: "amazon.de",
  FR: "amazon.fr",
  ES: "amazon.es",
  IT: "amazon.it",
  NL: "amazon.nl",
  BE: "amazon.com.be",
  SE: "amazon.se",
  PL: "amazon.pl",
  TR: "amazon.com.tr",
  AU: "amazon.com.au",
  JP: "amazon.co.jp",
  IN: "amazon.in",
  SG: "amazon.sg",
  AE: "amazon.ae",
  SA: "amazon.sa",
  EG: "amazon.eg",
};

// Pick the best Amazon store for the visitor, defaulting to amazon.com.
const getAmazonUrl = () => {
  let region = "US";
  try {
    const locale =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      "en-US";
    const parts = locale.split("-");
    if (parts[1]) region = parts[1].toUpperCase();
  } catch (e) {
    // navigator unavailable (SSR / older browsers) -> keep default
  }
  const domain = AMAZON_DOMAINS[region] || "amazon.com";
  return `https://www.${domain}/dp/${ASIN}`;
};

const BookPromo = ({ coverImage }) => {
  // Resolve the URL on the client so navigator is available.
  const [amazonUrl, setAmazonUrl] = useState(`https://www.amazon.com/dp/${ASIN}`);

  useEffect(() => {
    setAmazonUrl(getAmazonUrl());
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#2e2e2e",
        border: "2px solid #FF9900",
        borderRadius: "20px",
        padding: "30px",
        margin: "40px auto",
        maxWidth: "900px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        display: "flex",
        flexWrap: "wrap",
        gap: "30px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Book cover */}
      <a
        href={amazonUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ flex: "0 0 auto" }}
      >
        <img
          src={coverImage}
          alt="The Complete Guide to Exposure and Response Prevention — book cover"
          style={{
            width: "200px",
            maxWidth: "100%",
            height: "auto",
            borderRadius: "10px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
            display: "block",
          }}
        />
      </a>

      {/* Text + CTA */}
      <div style={{ flex: "1 1 320px", minWidth: "280px", color: "white" }}>
        <div
          style={{
            backgroundColor: "#FF9900",
            color: "#111",
            padding: "6px 16px",
            borderRadius: "20px",
            display: "inline-block",
            marginBottom: "15px",
            fontSize: "13px",
            fontWeight: "bold",
          }}
        >
          📖 NEW BOOK
        </div>

        <h2 style={{ marginBottom: "10px", lineHeight: "1.3" }}>
          The Complete Guide to Exposure and Response Prevention
        </h2>
        <p style={{ fontSize: "16px", color: "#ccc", marginBottom: "18px" }}>
          Breaking Free from OCD — A Step-by-Step Self-Help Guide to Reclaiming
          Your Life, by Olivier Charles.
        </p>

        <p style={{ fontSize: "15px", lineHeight: "1.6", marginBottom: "20px" }}>
          A practical, evidence-based companion to your ERP journey: learn how to
          build exposure hierarchies, resist compulsions, and steadily take back
          control — at your own pace.
        </p>

        <a
          href={amazonUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            backgroundColor: "#FF9900",
            color: "#111",
            padding: "14px 28px",
            borderRadius: "25px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "16px",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e88b00")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FF9900")}
        >
          🛒 Get it on Amazon
        </a>

        <p style={{ fontSize: "12px", color: "#999", marginTop: "12px" }}>
          Available on Kindle in your local Amazon store.
        </p>
      </div>
    </div>
  );
};

export default BookPromo;